"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSchemaDefaults = void 0;
const json_utils_1 = require("./json-utils");
/**
 *
 * @param schema
 * @param useEmptyValues Will return "" for type:string if no default is given
 * @returns
 */
// eslint-disable-next-line complexity
function getSchemaDefaults(schema, useEmptyValues = true) {
    schema = (0, json_utils_1.cloneObject)(schema);
    if (typeof schema.default !== "undefined")
        return schema.default;
    switch (schema.type) {
        case "object":
            if (!schema.properties)
                return undefined;
            for (const key in schema.properties) {
                if (schema.properties.hasOwnProperty(key)) {
                    schema.properties[key] = getSchemaDefaults(schema.properties[key], useEmptyValues);
                    if (typeof schema.properties[key] === "undefined") {
                        delete schema.properties[key];
                    }
                }
            }
            return schema.properties;
        case "array": {
            if (!schema.items)
                return undefined;
            // minimum item count
            const ct = schema.minItems || 0;
            // tuple-typed arrays
            if (schema.items.constructor === Array) {
                const values = schema.items.map(function (item) {
                    return getSchemaDefaults(item, useEmptyValues);
                });
                // remove undefined items at the end (unless required by minItems)
                for (let i = values.length - 1; i >= 0; i--) {
                    if (typeof values[i] !== "undefined") {
                        break;
                    }
                    if (i + 1 > ct) {
                        values.pop();
                    }
                }
                return values;
            }
            // object-typed arrays
            const value = getSchemaDefaults(schema.items, useEmptyValues);
            if (typeof value === "undefined") {
                return [];
            }
            else {
                const values = [];
                for (let i = 0; i < Math.max(1, ct); i++) {
                    values.push((0, json_utils_1.cloneObject)(value));
                }
                return values;
            }
        }
        case "string":
            if (useEmptyValues === true)
                return "";
            return undefined;
        case "boolean":
            if (useEmptyValues === true)
                return false;
            return undefined;
        case "number":
            if (useEmptyValues === true)
                return 0;
            return undefined;
    }
}
exports.getSchemaDefaults = getSchemaDefaults;
